import React from 'react';
import PropTypes from "prop-types";
import { Row, Col } from "antd";
import { LabelDataHeading, ContentDivider, UnderlyingContent } from '../../style';
import { CardContainer, CardDataHeadingValue } from '../RenderCard/style';
import { formatAmount } from "../../../../../../utils/commonUtil";

export default function GrantScheduleCard({
  data,
  showActions,
  noOfPayments,
  removeSpawn,
  grantAmountLabel = "Grant Amount",
  dateLabel = "Scheduled Issue Date",
}) {
  return data.map((elem, index) => (
    <CardContainer key={data.grantName} index={index}>
      <CardDataHeadingValue className="mb-20">{elem.grantName}</CardDataHeadingValue>
      <Row>
        <Col span={12}>
          <LabelDataHeading>{grantAmountLabel}</LabelDataHeading>
          <CardDataHeadingValue>{formatAmount(elem.amount)}</CardDataHeadingValue>
        </Col>
        <Col span={12}>
          <LabelDataHeading>{dateLabel}</LabelDataHeading>
          <CardDataHeadingValue>{elem.scheduledDate}</CardDataHeadingValue>
        </Col>
      </Row>
      {showActions && (
        <>
          <ContentDivider />
          <Row>
            <Col span={12}>
              {(noOfPayments > 2 && (index + 1) === parseInt(noOfPayments, 10)) 
              ? <UnderlyingContent onClick={removeSpawn}>Remove</UnderlyingContent>
              : null
              }
            </Col>
          </Row>
        </>
      )}
    </CardContainer>
  ));
}

GrantScheduleCard.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.string, 
      grantName: PropTypes.string, 
      scheduledDate: PropTypes.string, 
    })
  ),
  showActions: PropTypes.bool,
  noOfPayments: PropTypes.number,
  removeSpawn: PropTypes.func, 
  grantAmountLabel: PropTypes.string,
  dateLabel: PropTypes.string,
}
